export default {
    // private
   subscription:'/subscription',
   profile: '/profile',
   reports:'/reports'
};
